import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import NotFound from "./features/notfound/NotFound";
import { ThemeProvider } from "./features/theme/themeProvider";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // データを常に最新にするため、staleTimeを短くする
      staleTime: 0, // データを即座にstaleにする
      // キャッシュ時間を短縮（デフォルト: 5分）
      gcTime: 1 * 60 * 1000, // 1分でキャッシュを削除
      // ウィンドウフォーカス時に再取得
      refetchOnWindowFocus: true,
      // マウント時に再取得
      refetchOnMount: true,
      // 再接続時に再取得
      refetchOnReconnect: true,
      // エラー時の再試行回数
      retry: 1,
    },
    mutations: {
      // 成功時にキャッシュを無効化
      onSuccess: () => {
        queryClient.invalidateQueries();
      },
    },
  },
})
const router = createRouter({
  routeTree, defaultNotFoundComponent: NotFound,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
